import { utils } from '@tradetrust-tt/token-registry-v4';

const { computeTitleEscrowAddress, encodeInitParams, getEventFromReceipt, computeInterfaceId } = utils;

export { computeInterfaceId, computeTitleEscrowAddress, encodeInitParams, getEventFromReceipt };
